import { colors } from 'astralbeam-design';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  html {
    font-family: 'Inter', sans-serif;
    box-sizing: border-box;
    overflow-y: visible;
    /* Reserve scrollbar space so layout doesn't shift when content height changes */
    scrollbar-gutter: stable;
  }

  @media (max-width: 767px) {
    html {
      overflow-x: hidden;
    }
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  @supports (font-variation-settings: normal) {
    html {
      font-family: 'Inter var', sans-serif;
    }
  }

  body {
    font-weight: normal;
    color: #1a1919;
    margin: unset;
    background: ${colors.bg.void};
  }

  b {
    font-weight: 700;
  }

  button,
  a {
    cursor: pointer;
    text-decoration: none;
  }

  a:focus,
  button:focus,
  input:focus,
  textarea:focus {
    outline: none;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

`;
